import DynamicImage from "./DynamicImage";
import { useState } from "react";
import QrcodeDialog from "./QrcodeDialog";

const Qrcode = () => {
  return (
    <QrcodeDialog>
      <div
        className="rounded-cycle w-[86px] h-[86px] bg-white fixed z-50 flex flex-col justify-center items-center gap-y-1 top-[800px] right-8"
        style={{ boxShadow: '0px 1px 6px 0px rgba(0, 0, 0, 0.1)' }}
      >
        <DynamicImage
          src="https://osscdn.weiyouzhihui.com/staticIcon/home/kefu.png"
          width={30}
          height={30}
        ></DynamicImage>
        <span className="text-black/85 text-sm w-full text-center">联系我们</span>
      </div>
    </QrcodeDialog>
  );
};

export default Qrcode;
